import { render, staticRenderFns } from "./policyDialog.vue?vue&type=template&id=2c05d284&scoped=true&"
import script from "./policyDialog.vue?vue&type=script&lang=js&"
export * from "./policyDialog.vue?vue&type=script&lang=js&"
import style0 from "./policyDialog.vue?vue&type=style&index=0&id=2c05d284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05d284",
  null
  
)

export default component.exports